import { Props as RecordDetailProps } from "./RecordDetail";
export { default } from "./RecordDetail";

export type Props = RecordDetailProps;
